import Layout from '@/components/Layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import EmailDominiosTab from '@/components/email/EmailDominiosTab';
import EmailTemplatesTab from '@/components/email/EmailTemplatesTab';
import EmailCampanhasTab from '@/components/email/EmailCampanhasTab';

export default function Email() {
  return (
    <Layout>
      <div className="container mx-auto py-6 space-y-6">
        <div>
          <h1 className="text-2xl font-semibold">Email</h1>
          <p className="text-sm text-muted-foreground">
            Configure domínios de envio, templates e campanhas de email.
          </p>
        </div>

        <Tabs defaultValue="dominios" className="w-full">
          <TabsList>
            <TabsTrigger value="dominios">Domínios</TabsTrigger>
            <TabsTrigger value="templates">Templates</TabsTrigger>
            <TabsTrigger value="campanhas">Campanhas</TabsTrigger>
          </TabsList>
          <TabsContent value="dominios" className="mt-6">
            <EmailDominiosTab />
          </TabsContent>
          <TabsContent value="templates" className="mt-6">
            <EmailTemplatesTab />
          </TabsContent>
          <TabsContent value="campanhas" className="mt-6">
            <EmailCampanhasTab />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
